<template>
  <div class="mb-8 message"
       :class="{userMessage}">
    <div class="message__avatar">
      <div v-if="userMessage"
           class="text-lg text-white">{{ displayedName[0].toUpperCase() }}
      </div>
      <IconProfileBold v-else class="text-text-muted"/>
    </div>
    <div class="center">
      <div class="message__cloud">
        <div>{{ message.text }}</div>
        <div class="time">{{ messageTime }}</div>
      </div>
      <div class="message__attachments" v-if="attachedImages.length || attachedFiles.length">
        <silent-box v-if="attachedImages.length"
                    :gallery="attachedImages"
                    class="gallery --mk-theme"></silent-box>
        <div v-if="attachedFiles.length" class="gallery">
          <a v-for="(file,i) in attachedFiles"
             class="attached-file"
             :href="`${file.src}`">
            <IconFile class="mb-6 text-border-hover"/>
            <div class="truncate max-w-full">
              {{ file.file_name }}
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import IconProfileBold from "@/components/icons/IconProfileBold";
import IconFile from "@/components/icons/IconFile";

export default {
  name: "TicketsChatMessagesItem",
  components: {IconFile, IconProfileBold},
  props: {
    message: {
      type: Object,
      required: true
    },
    userMessage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('cabinet/user', ['displayedName']),
    messageTime() {
      return this.$moment.unix(this.message.created_at).locale(this.$i18n.locale).format('DD MMM, HH:mm')
    },
    attachedImages() {
      const imageTypeRegExp = new RegExp('\\bimage\\b', 'g');
      return this.message.attachments
          .filter(item => item.type.match(imageTypeRegExp))
          .map(item => ({
            ...item,
            src: `${process.env.VUE_APP_BASE_URL || process.env.BASE_URL}${item.file_path}`
          }));
    },
    attachedFiles() {
      const imageTypeRegExp = new RegExp('\\bimage\\b', 'g');
      return this.message.attachments
          .filter(item => !item.type.match(imageTypeRegExp))
          .map(item => ({
            ...item,
            src: `${process.env.VUE_APP_BASE_URL || process.env.BASE_URL}${item.file_path}`
          }));
    }
  }
}
</script>

<style lang="scss">
.message {
  @apply flex items-end mr-auto;
  &__cloud {
    @apply text-sm ml-4 flex flex-col text-text whitespace-pre-wrap;
    word-break: break-word;
    width: 600px;
    padding: 24px 28px 22px 28px;
    background: #F0F4F7;
    border: 1px solid #DFE9ED;
    box-sizing: border-box;
    border-radius: 10px 10px 10px 0;
  }

  .time {
    @apply text-border-hover text-sm ml-auto;
  }

  &__avatar {
    @apply rounded-full bg-border-hover flex items-center justify-center mr-4;
    min-width: 50px;
    width: 50px;
    height: 50px;
  }

  &__attachments {
    @apply ml-4;
    .gallery {
      @apply flex flex-wrap ml-auto -mx-2;
      a {
        @apply rounded overflow-hidden border border-border mx-2 mt-4 transition duration-200;
        height: 96px;
        width: auto;

        img {
          max-width: unset;
          height: 100%;
        }

        &:hover {
          @apply border-border-hover;
        }
      }

      .attached-file {
        @apply flex flex-col items-center justify-center px-8 bg-line text-text text-sm;
        max-width: 140px;
      }
    }
  }

  &.userMessage {
    @apply ml-auto mr-0 flex-row-reverse;

    .message__avatar {
      @apply ml-4 mr-0 bg-red;
    }

    .message__cloud {
      @apply bg-text-label text-white mr-4 relative border-0;
      border-radius: 10px 10px 0 10px;
    }

    .message__attachments {
      @apply ml-0 mr-4 text-right;
      .gallery {
        @apply justify-end;
      }
    }
  }

  @media(max-width: 1199px) {
    &__cloud {
      width: auto;
      max-width: 240px;
      padding: 8px 16px;

      .time {
        margin-top: 8px;
      }
    }
  }
}
</style>